module.exports = __webpack_public_path__ + "img/veri.14fa419a.jpg";